<template>
  <div ref="dropdown" class="relative w-fit">
    <button
      id="languageToggler"
      class="flex items-center gap-3 text-xs leading-[2.2]"
      @click="isActive = !isActive"
    >
      <span>{{ activeLocale }}</span>
      <Icon
        name="chevron"
        color="#D5DAD0"
        size="2xs"
        class="mb-px transition-transform duration-300"
        :class="isActive && 'rotate-180'"
      />
    </button>
    <Transition name="fade">
      <ul
        v-if="isActive"
        class="absolute bottom-full left-0 z-10 mb-3 bg-light-gray p-2 text-left text-neutral-900 shadow-lg shadow-[#21252914] lg:left-auto lg:right-0"
        aria-labelledby="languageToggler"
      >
        <li v-for="(item, idx) in locales" :key="idx" class="mt-1 first:mt-0">
          <button
            class="flex h-10 w-full items-center justify-between gap-2 px-3 text-left text-sm transition-colors duration-300 hover:bg-blue-900 hover:text-white"
            :class="{ 'bg-blue-900 text-white': item.code === locale }"
            :disabled="item.code === locale"
            @click="switchLanguage(item.code)"
          >
            {{ item.name }}
            <Icon v-if="item.code === locale" name="checked" color="white" size="sm" />
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import type { LocaleObject } from '@nuxtjs/i18n'

const { locale, locales } = useI18n()
const isActive = ref(false)

const dropdown = ref(null)
onClickOutside(dropdown, () => hideDropdown())

const activeLocale = computed(
  () => locales.value.find((l: LocaleObject) => l.code === locale.value)?.name
)

function hideDropdown() {
  isActive.value = false
}

const switchLanguage = (lang: string) => {
  const country = useCookie('nf_country')
  const language = useCookie('nf_lang')

  country.value = lang
  language.value = lang

  if (lang === 'sl') {
    window.location.replace('/')
  } else {
    window.location.replace(`/${lang}`)
  }

  isActive.value = false
}
</script>
